<template>
  <div class="my-chart" ref="myChart"></div>
</template>
<script>
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core'
// 引入柱状图图表，图表后缀都为 Chart
import { LineChart } from 'echarts/charts'
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DataZoomComponent
} from 'echarts/components'
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features'
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers'
import { options as canvasOptions } from './data.js'
// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
  DataZoomComponent,
  LineChart
])
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    options: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      myChart: null,
      canvasOptions: canvasOptions
    }
  },
  watch: {
    data(data) {
      this.init(true)
    }
  },
  mounted() {
    let div = this.$refs.myChart
    div = Array.isArray(div) ? div[0] : div
    console.log(div.offsetWidth)
    setTimeout(() => {
      this.init()
    }, 100)
  },
  methods: {
    //检查参数是否合法
    checkParams() {
      if (
        !Object.keys(this.options).length &&
        this.data.xList.length != this.data.yList.length
      ) {
        return false
      }
      return true
    },
    /**
     * 加载echarts
     */
    init(render) {
      console.log(this.canvasOptions)
      //如果自己传入参数则使用传入参数 xy轴数据必须在参数内
      if (Object.keys(this.options).length) {
        this.canvasOptions = this.options
      } else {
        //如果未传入则使用默认 但是需要初始化xy轴数据
        this.canvasOptions.xAxis.data = this.data.xList
        this.canvasOptions.series[0].data = this.data.yList
      }
      console.log(this.canvasOptions)
      // 接下来的使用就跟之前一样，初始化图表，设置配置项
      let div = this.$refs.myChart
      div = Array.isArray(div) ? div[0] : div
      this.myChart = echarts.init(div)
      //让图表默认展示最右边
      this.canvasOptions.dataZoom[0].startValue =
        this.canvasOptions.series[0].data.length - 7
      this.canvasOptions.dataZoom[0].endValue =
        this.canvasOptions.series[0].data.length - 1
      this.myChart.setOption(this.canvasOptions, render)
    }
  }
}
</script>
<style lang="scss" scoped>
.my-chart {
  width: 100%;
  height: 100%;
}
</style>
